"use strict";
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _slicedToArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateServiceStub = void 0;
/* global window */

/* global AbortController */

var node_fetch_1 = require("node-fetch");

var abort_controller_1 = require("abort-controller");

var featureDetection_1 = require("./featureDetection");

function generateServiceStub(rpcs, protocol, servicePath, servicePort, authClient, requestEncoder, responseDecoder) {
  var fetch = featureDetection_1.hasWindowFetch() ? window.fetch : node_fetch_1.default;
  var serviceStub = {};

  var _loop = function _loop() {
    var _ref = _Object$entries[_i];
    _ref2 = _slicedToArray(_ref, 2);
    var rpcName = _ref2[0];
    var rpc = _ref2[1];

    serviceStub[rpcName] = function (request, options, _metadata, callback) {
      // We cannot use async-await in this function because we need to return the canceller object as soon as possible.
      // Using plain old promises instead.
      var cancelController = featureDetection_1.hasAbortController() ? new AbortController() : new abort_controller_1.AbortController();
      var cancelSignal = cancelController.signal;
      var cancelRequested = false;
      var fetchParameters = requestEncoder(rpc, protocol, servicePath, servicePort, request);
      var url = fetchParameters.url;
      var headers = fetchParameters.headers;

      for (var _i2 = 0, _Object$keys = Object.keys(options); _i2 < _Object$keys.length; _i2++) {
        var key = _Object$keys[_i2];
        headers[key] = options[key][0];
      }

      authClient.getRequestHeaders().then(function (authHeader) {
        var fetchRequest = {
          headers: _objectSpread({}, authHeader, {}, headers),
          body: fetchParameters.body,
          method: fetchParameters.method,
          signal: cancelSignal
        };

        if (fetchParameters.method === 'get' || fetchParameters.method === 'delete') {
          delete fetchRequest['body'];
        }

        return fetch(url, fetchRequest);
      }).then(function (response) {
        return Promise.all([Promise.resolve(response.ok), response.arrayBuffer()]);
      }).then(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            ok = _ref4[0],
            buffer = _ref4[1];

        var response = responseDecoder(rpc, ok, buffer);
        callback(null, response);
      }).catch(function (err) {
        if (!cancelRequested || err.name !== 'AbortError') {
          callback(err);
        }
      });
      return {
        cancel: function cancel() {
          cancelRequested = true;
          cancelController.abort();
        }
      };
    };
  };

  for (var _i = 0, _Object$entries = Object.entries(rpcs); _i < _Object$entries.length; _i++) {
    var _ref2;

    _loop();
  }

  return serviceStub;
}

exports.generateServiceStub = generateServiceStub;